import { render, staticRenderFns } from "./detail-header.vue?vue&type=template&id=19330428&scoped=true&"
import script from "./detail-header.vue?vue&type=script&lang=js&"
export * from "./detail-header.vue?vue&type=script&lang=js&"
import style0 from "./detail-header.vue?vue&type=style&index=0&id=19330428&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19330428",
  null
  
)

export default component.exports